import React, { useContext } from 'react';
import { Avatar, Box, Button } from '@mui/material';
import moment from 'moment';
import { AppContext } from '../../AppContext';
import { Roles } from '../../enums/RoleEnums';
import { IComment } from '../../generated/graphql';
import { Colors } from '../../utils/theme';
import PaperCard from '../Common/Layout/PaperCard';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import removeIcon from '../../assets/images/actions/trash.svg';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import removeIconDisabled from '../../assets/images/actions/trash_gray.svg';

type IProps = {
  comment: IComment;
  remove: (comment: IComment) => void;
  index: number;
};

const Comment: React.FunctionComponent<IProps> = ({ comment, remove, index }: IProps) => {
  const namesFirstLetters = comment.author.first_name[0] + comment.author.last_name[0];
  const fullName = `${comment.author.first_name} ${comment.author.last_name}`;
  const { state } = useContext(AppContext);
  const canDeleteComment = state.user.data?.roles.includes(Roles.Admin);

  return (
    <Box sx={{ display: 'grid', paddingLeft: '5.5%', paddingTop: '20px', paddingRight: '3.3%' }}>
      <Box sx={{ gridColumn: 'span 1' }}>
        <Avatar
          id={`comment-${index}-avatar`}
          data-testid={`comment-${index}-avatar`}
          sx={{
            backgroundColor: '#DFDFE0',
            border: `4px solid ${Colors.skyBlue}`,
            color: Colors.skyBlue,
            width: '45px',
            height: '44px'
          }}
        >
          {namesFirstLetters}
        </Avatar>
      </Box>
      <Box sx={{ gridColumn: 'span 10' }}>
        <Box
          id={`comment-${index}-author-name`}
          data-testid={`comment-${index}-author-name`}
          sx={{
            color: Colors.skyBlue
          }}
        >
          {fullName}
        </Box>
        <Box
          id={`comment-${index}-creation-date`}
          data-testid={`comment-${index}-creation-date`}
          sx={{ color: Colors.gray }}
        >
          {moment(parseInt(comment.date)).format('DD.MM.YYYY HH:mm')}
        </Box>
      </Box>
      <Box display="flex" justifyContent="end" sx={{ gridColumn: 'span 1' }}>
        <Button
          id={`remove-comment-${index}-button`}
          sx={{ width: '10px' }}
          onClick={() => remove(comment)}
          data-testid={`remove-comment-${index}-button`}
          disabled={!canDeleteComment}
        >
          <img src={canDeleteComment ? removeIcon : removeIconDisabled} alt="removeButton" />
        </Button>
      </Box>
      <Box
        id={`comment-${index}-text`}
        data-testid={`comment-${index}-text`}
        sx={{ color: Colors.main, gridColumn: 'span 12', paddingBottom: '10px' }}
      >
        {comment.text}
      </Box>
    </Box>
  );
};

export default Comment;
